import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { reducer as formReducer } from 'redux-form';
import { Grid, Row, Col } from 'react-bootstrap';
import { I18nextProvider } from 'react-i18next';
import * as Sentry from '@sentry/browser';

import 'bootstrap/dist/css/bootstrap.css';
import mainReducer from './reducers/main';
import LoginContainer from './components/login/LoginContainer';
import ChatLoginContainer from './components/login/ChatLoginContainer';
import PurchaseLoginContainer from './components/login/PurchaseLoginContainer';
import CommerceLoginContainer from './components/login/CommerceLoginContainer';
import RegistrationContainer from './components/registration/RegistrationContainer';
import ChatRegistrationContainer from './components/registration/ChatRegistrationContainer';
import PurchaseRegistrationContainer from './components/registration/PurchaseRegistrationContainer';
import CommerceRegistrationContainer from './components/registration/CommerceRegistrationContainer';
import ResetPasswordContainer from './components/resetPassword/ResetPasswordContainer';
import ResetPasswordPerformContainer from './components/resetPassword/ResetPasswordPerformContainer';
import VerifyEmailContainer from './components/verifyEmail/verifyEmailContainer';
import RestrictedContainer from './components/info/RestrictedContainer';
import DemoContainer from './components/info/DemoContainer';
import InvalidLink from './components/info/InvalidLink';
import i18n from './i18n';
import GoogleTagManager from './components/GoogleTagManager';
import history from './history';
import './css/common.styl';
import CatchErrors from './CatchErrors';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://73340ff28b7f47f6b38728a950506d40@sentry.goodwix.com/3',
    environment: process.env.NODE_ENV
  });
}

const styles = {
  minHeight: '500px',
  margin: '100px auto 0',
  display: 'flex',
  justifyContent: 'center'
};

const app = document.createElement('div');
app.setAttribute('id', 'app');
document.body.insertBefore(app, document.body.firstChild);

// const script = document.createElement('script');
// script.setAttribute("src","http://whatever.com/the/script.js");
// document.getElementsByTagName('head')[0].appendChild(script);

// const createStoreWithMiddleware = applyMiddleware(
//   thunkMiddleware,
//   remoteActionMiddleware
// )(createStore);
// const store = createStoreWithMiddleware(mainReducer);

const reducer = combineReducers({
  main: mainReducer,
  form: formReducer
});

const store = createStore(
  reducer,
  compose(applyMiddleware(thunkMiddleware), window.devToolsExtension ? window.devToolsExtension() : f => f)
);

if (process.env.GA_ENABLED) {
  ReactGA.initialize(process.env.GA_TRACK);
}

ReactDOM.render(
  <CatchErrors>
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <Router history={history}>
          <Grid>
            <GoogleTagManager />
            <Row className="show-grid">
              <Col>
                <div style={styles}>
                  <Switch>
                    <Route exact path="/" render={() => <Redirect to="/login" />} />
                    <Route exact path="/welcome/login/:tokenLink" component={LoginContainer} />
                    <Route exact path="/welcome/partner/login/:partnerToken" component={LoginContainer} />
                    <Route exact path="/login/invite-hidden-employee/:hiddenEmployeeToken" component={LoginContainer} />
                    <Route exact path="/login" component={LoginContainer} />
                    <Route exact path="/welcome/registration/:tokenLink" component={RegistrationContainer} />
                    <Route exact path="/welcome/partner/registration/:partnerToken" component={RegistrationContainer} />
                    <Route exact path="/registration" component={RegistrationContainer} />
                    <Route exact path="/registration/:token" component={RegistrationContainer} />
                    <Route exact path="/reset-password" component={ResetPasswordContainer} />
                    <Route exact path="/reset-password/perform" component={ResetPasswordPerformContainer} />
                    <Route exact path="/verify-email" component={VerifyEmailContainer} />
                    <Route exact path="/restricted" component={RestrictedContainer} />
                    <Route exact path="/demo" component={DemoContainer} />
                    <Route exact path="/invalid-link" component={InvalidLink} />
                    <Route exact path="/chat/login" component={ChatLoginContainer} />
                    <Route exact path="/chat/registration" component={ChatRegistrationContainer} />
                    <Route exact path="/purchase/login" component={PurchaseLoginContainer} />
                    <Route exact path="/purchase/registration" component={PurchaseRegistrationContainer} />
                    <Route exact path="/commerce/login" component={CommerceLoginContainer} />
                    <Route exact path="/commerce/registration" component={CommerceRegistrationContainer} />
                    <Redirect to="/login" />
                  </Switch>
                </div>
              </Col>
            </Row>
          </Grid>
        </Router>
      </Provider>
    </I18nextProvider>
  </CatchErrors>,
  app
);



// WEBPACK FOOTER //
// ./index.jsx